import { render, staticRenderFns } from "./select-item-from-provided-list.vue?vue&type=template&id=6dfae8b6&"
import script from "./select-item-from-provided-list.vue?vue&type=script&lang=js&"
export * from "./select-item-from-provided-list.vue?vue&type=script&lang=js&"
import style0 from "./select-item-from-provided-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports